module.exports = "https://coursera_assets.s3.amazonaws.com/images/98592229e05192c42b7880fbbd241d7a.png";